













































import gtag from "ga-gtag";
import Vue from "vue";
import FeatureGroup from "../components/FeatureGroup.vue";

export default Vue.extend({
  name: "ProductLessonb",
  metaInfo: {
    title: "Lessonb - Lesson planner for teachers",
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Lessonb is a simple but useful application that helps teachers easily create lesson plans quickly and conveniently. With this app, you no longer have to worry or be tired of having to carry around a variety of teaching materials. Lessonb is all you need to effectively teach in class:" }
    ]
  },
  components: {
    FeatureGroup,
  },
  data() {
    return {
      basicFeatureGroup: [
        { title: "General", text: "What is the purpose of this lesson?" },
        {
          title: "Activities",
          text: "What activities do you want to organize in class?",
        },
        { title: "Note", text: "What should be noted in this lesson plan?" },
      ],
      premiumFeatureGroup: [
        {
          title: "Markdown",
          text: "Format text with markdown",
          color: "#ff4e00",
        },
        {
          title: "Files",
          text: "Store files in your lesson plan",
          color: "#ff4e00",
        },
        { title: "No ads", text: "Annoying ads disappear", color: "#ff4e00" },
      ],
    };
  },
  methods: {
    downloadLessonb() {
      gtag("event", "download", {
        'event_category': "download",
        'event_label': "download_lessonb",
      });
    },
  },
});
